import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        "custom-class": _ctx.customClass,
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
        title: _ctx.title,
        width: _ctx.width,
        fullscreen: _ctx.fullscreen,
        draggable: _ctx.draggable,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "destroy-on-close": "",
        onOpened: _ctx.onOpened,
        onClosed: _ctx.onClosed
      }, _createSlots({
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        (_ctx.showFooter)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "footer", {}, () => [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: _cache[0] || (_cache[0] = 
              () => {
                _ctx.onCancel()
                _ctx.close()
                _ctx.onClosed()
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.showSubmit ? '取消' : '关闭'), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.showSubmit)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            onClick: _ctx.onSubmit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("提交")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["custom-class", "modelValue", "title", "width", "fullscreen", "draggable", "onOpened", "onClosed"]))
    : _createCommentVNode("", true)
}